:host {
  display: table-header-group;
}

::slotted(*) {
  display: table-row;
}
